<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router'
import { useServiceStore } from '@/stores/serviceStore';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';
import BasePhoneInput from '@/components/ui/BasePhoneInput.vue';
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue';
import Loader from '@/components/ui/Loader.vue';

const storeService = useServiceStore();
const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const router = useRouter()

const isScreenLoading = ref(storeRequests.isAuthenticated)

const isAuth = computed(() => storeRequests.isAuthenticated && storeRequests.userData?.is_full_profile)

const nextSreen = async () => {
    await storeRequests.authorization();
    if(!storeRequests.responseOk) return;
    storeService.goToScreen(storeService.screens.authSms)
    router.push({ hash: `#${storeService.screens.authSms}`})
    storeService.timer()
    storeRequests.responseOk = null
};

const resetFields = () => {
    storeField.updateFields('phone', 'title', '')
    storeField.updateFields('phone', 'disabledBtn', false)
    storeField.updateFields('agreement', 'title', '')
    storeField.updateFields('agreement', 'disabledBtn', false)
    storeRequests.responseError = ''
}

onMounted( async  () => {
    resetFields()
    if(storeRequests.isAuthenticated) {
        await storeRequests.userInfo();
        if(isAuth.value) {
            storeService.goToScreen(storeService.screens.services)
            router.push({ hash: `#${storeService.screens.services}`})
        } else {
            isScreenLoading.value = false
        }
    }
})
</script>
<template>
    <div class="container" v-if="!isAuth">
        <Loader v-if="isScreenLoading"/>
        <template v-else>
            <h2 class="service-title">авторизация</h2>
            <div class="services-form">
                <div class="form">
                    <p class="form__subtitle">Для доступа к разделу необходимо авторизоваться.</p>
                    <div :class="['form__row ', ]">
                        
                        <BasePhoneInput 
                            :required="true"
                            placeholder="+7 (___) ___ ____"
                            state-key="phone" 
                                                                   
                        >
                            Номер телефона
                        </BasePhoneInput>
                    </div>
                    <div class="rules">
                        <BaseCheckbox
                            state-key="agreement"
                            v-model="storeField.fields.agreement.title"
                        >
                            Ознакомлен с правилами, согласен на обработку <a target="_blank" :href="storeSettings.privacy_policy">персональных данных</a>
                        </BaseCheckbox> 
                    </div>
                    <p class="form-text-error" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
                    <button 
                        class="btn --full" 
                        :disabled="storeField.isBtnDisabled(['phone','agreement'])" 
                        @click="nextSreen"
                    >
                        <span v-if="!storeRequests.loaderBtn">Получить смс-код</span>
                        <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                    </button>
                </div>
            </div>
        </template>        
    </div>
</template>
<style lang='scss' scoped>

</style>